import { TotalUsersType } from "../../../entities/user";
import UserRepository from "../../ports/userRepository";

export type fetchTotalUsersUsecase = () => Promise<TotalUsersType>;

export const buildFetchTotalUsers = (dependencies: {
  userRepo: UserRepository;
}): fetchTotalUsersUsecase => {
  const { userRepo } = dependencies;

  const fetchTotalUsers: fetchTotalUsersUsecase = async () => userRepo.fetchTotalUsers();

  return fetchTotalUsers;
};
